import { createStore, createContainer, createHook, type StoreActionApi } from 'react-sweet-state';
import { BASE_HEADER_HEIGHT, DEFAULT_SUBHEADER_HEIGHT } from '../../constants';
import { actions, type Actions } from './actions';
import type { Props, State } from './types';

const initialState: State = {
	headerItems: [],
	headerHeight: BASE_HEADER_HEIGHT,
	headerItemsOffsetTop: {},
	isRowCountKnown: true,
};

export const headerStore = createStore<State, Actions>({
	initialState,
	actions,
	name: 'timeline-table.header',
});

export const useHeaderState = createHook(headerStore);

const handleState =
	() =>
	({ setState }: StoreActionApi<State>, { headerItems, isRowCountKnown }: Props) => {
		let offsetTop = BASE_HEADER_HEIGHT;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const headerItemsOffsetTop: Record<string, any> = {};
		const headerHeight = headerItems.reduce((total, { id, height }) => {
			headerItemsOffsetTop[id] = offsetTop;
			offsetTop += height !== undefined ? height : DEFAULT_SUBHEADER_HEIGHT;
			return total + (height ?? DEFAULT_SUBHEADER_HEIGHT);
		}, BASE_HEADER_HEIGHT);

		setState({
			headerItems,
			headerItemsOffsetTop,
			headerHeight,
			isRowCountKnown,
		});
	};

const HeaderProvider = createContainer<State, Actions, Props>(headerStore, {
	onInit: handleState,
	onUpdate: handleState,
});

export default HeaderProvider;
